import { Elements } from '@kontent-ai/delivery-sdk';

/**
 * Interface for components that include advanced text functionality
 */
export interface WithAdvancedText {
  /**
   * Advanced text custom element from Kontent.ai
   */
  advancedText?: Elements.CustomElement;
}

/**
 * Helper function to extract advanced text content from Kontent.ai custom element
 * @param advancedTextElement - The custom element from Kontent.ai
 * @returns The string content or undefined
 */
export const getAdvancedTextContent = (advancedTextElement?: Elements.CustomElement): string | undefined => {
  return advancedTextElement?.value;
};

/**
 * Type for the AdvancedText component props
 */
export interface AdvancedTextProps {
  content?: string;
  className?: string;
}
